import React from 'react';
import RecordSourceWrapperIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecordSourceWrapperIcon';
import { RECORD_SOURCE_ICON_SIZE } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/constant/recordSourceIconSize';

const WorkOrdersIcon: React.FC = () => {
  return (
    <RecordSourceWrapperIcon className="bg-yellow-40">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={RECORD_SOURCE_ICON_SIZE.width}
        height={RECORD_SOURCE_ICON_SIZE.height}
        viewBox="0 0 13 13"
        fill="none"
      >
        <path
          d="M10.9375 3.38607C10.9375 4.39128 10.1198 5.20898 9.11458 5.20898C8.90104 5.20898 8.69792 5.16732 8.51042 5.09961L2.58333 11.0215L1.47917 9.91732L5.33854 6.05794L4.41146 5.13086L4.04167 5.50065L3.30729 4.76628V6.24023L2.9375 6.61003L1.09375 4.76628L1.46354 4.39648H2.93229L2.19792 3.66211L4.04167 1.81836C4.65104 1.20898 5.64062 1.20898 6.25 1.81836L5.14583 2.92253L5.88021 3.6569L5.51042 4.02669L6.4375 4.95378L7.40104 3.99023C7.33333 3.80273 7.29167 3.59961 7.29167 3.38607C7.29167 2.38086 8.10938 1.56315 9.11458 1.56315C9.41667 1.56315 9.69792 1.64648 9.94792 1.77669L8.54167 3.18294L9.31771 3.95898L10.724 2.55273C10.8542 2.80273 10.9375 3.08398 10.9375 3.38607Z"
          fill="white"
        />
        <path
          d="M7.17845 7.90226L8.28329 6.79742L11.4063 9.92044L10.3015 11.0253L7.17845 7.90226Z"
          fill="white"
        />
      </svg>
    </RecordSourceWrapperIcon>
  );
};

export default WorkOrdersIcon;
